// ข้อมูลตัวอย่างน้องๆ สำหรับทดสอบระบบ
export const sampleGirls = [
  {
    id: 'girl1',
    nickname: 'น้องแอม',
    grades: 4.5,
    type: 'normal',
    subscription: 'basic',
    description: 'สาวสวยใจดี รักการท่องเที่ยว หน้าตาน่ารัก บริการดี',
    momoName: 'มอมจอย',
    height: 165,
    weight: 50,
    skinTone: 'fair',
    // แยกราคาค่าบริการจริงกับเหรียญ
    servicePrice: 1500, // ราคาค่าบริการจริง (บาท)
    coinPrice: 50, // ราคาเหรียญที่ลูกค้าต้องจ่าย
    commission: 0.3, // ค่าคอมมิชชั่นของระบบ (30%)
    prices: { 
      base: 50, // เหรียญ (สำหรับ backward compatibility)
      servicePrice: 1500, // ราคาค่าบริการจริง
      coinPrice: 50 // ราคาเหรียญ
    },
    location: 'กาญจนบุรี',
    bio: 'สาวสวยใจดี รักการท่องเที่ยว',
    lineType: 'self',
    lineContact: 'am123',
    images: ['https://via.placeholder.com/300x400/FFB6C1/FFFFFF?text=Am'],
    status: 'available'
  },
  {
    id: 'girl2', 
    nickname: 'น้องบี',
    grades: 4.8,
    type: 'vn',
    subscription: 'premium',
    description: 'สาวน่ารัก หน้าตาดี บริการดีมาก มีประสบการณ์',
    momoName: 'มอมแอม',
    height: 160,
    weight: 48,
    skinTone: 'light',
    // แยกราคาค่าบริการจริงกับเหรียญ
    servicePrice: 2500, // ราคาค่าบริการจริง (บาท)
    coinPrice: 80, // ราคาเหรียญที่ลูกค้าต้องจ่าย
    commission: 0.35, // ค่าคอมมิชชั่นของระบบ (35%)
    prices: { 
      base: 80, // เหรียญ (สำหรับ backward compatibility)
      servicePrice: 2500, // ราคาค่าบริการจริง
      coinPrice: 80 // ราคาเหรียญ
    },
    location: 'กาญจนบุรี',
    bio: 'สาวน่ารัก หน้าตาดี',
    lineType: 'modeling',
    lineContact: 'modeling123',
    images: ['https://via.placeholder.com/300x400/FFC0CB/FFFFFF?text=Bee'],
    status: 'available'
  },
  {
    id: 'girl3',
    nickname: 'น้องซี',
    grades: 4.2,
    type: 'strong',
    subscription: 'vip',
    description: 'สาวแกร่ง ใจดี มีความมั่นใจสูง บริการดีเยี่ยม',
    momoName: 'มอมซี',
    height: 170,
    weight: 55,
    skinTone: 'medium',
    // แยกราคาค่าบริการจริงกับเหรียญ
    servicePrice: 1800, // ราคาค่าบริการจริง (บาท)
    coinPrice: 60, // ราคาเหรียญที่ลูกค้าต้องจ่าย
    commission: 0.32, // ค่าคอมมิชชั่นของระบบ (32%)
    prices: { 
      base: 60, // เหรียญ (สำหรับ backward compatibility)
      servicePrice: 1800, // ราคาค่าบริการจริง
      coinPrice: 60 // ราคาเหรียญ
    },
    location: 'กาญจนบุรี',
    bio: 'สาวแกร่ง ใจดี',
    lineType: 'self',
    lineContact: 'c123',
    images: ['https://via.placeholder.com/300x400/DDA0DD/FFFFFF?text=Cee'],
    status: 'available'
  }
];

